import { readable, writable } from 'svelte/store';

export const db = readable(firebase.firestore(), function start() {
    return function stop() {

    };
});


export const auth = readable(firebase.auth(), function start() {
    return function stop() {

    };
});

export const functions = readable(firebase.functions(), function start() {
    return function stop() {

    };
});

export const hashtag = writable("")

export const user = writable(undefined);

export const live = writable(false);

export const next_session = writable(0);

export const break_session = writable({});


/// Audioplayer
export const time = readable(new Date(), function start(set) {
    const interval = setInterval(() => {
        set(new Date());
    }, 1000);

    return function stop() {
        clearInterval(interval);
    }
});

export const isPlaying = writable(false);

export const playerLoaded = writable(false);

export const soundAlarm = writable('none');